import { useMemo } from 'react';

import { SelectedData } from '../types';

interface HighlightProducts {
    status: 'highlight' | 'unhighlight';
    selectedIds: number[];
}

export const useHighlightProducts = (productsFromCompleteSections: SelectedData[], productsFromPartialSections: SelectedData[]): HighlightProducts => {
    return useMemo(() => {
        const result: HighlightProducts = {
            status: 'highlight',
            selectedIds: []
        };
        if (!productsFromCompleteSections.length && !productsFromPartialSections.length) {
            return result;
        }

        const highLightedBodIds = new Set<number>();
        const notHighLightedBodIds = new Set<number>();

        productsFromCompleteSections.forEach((bod) => {
            if (bod.is_highlighted) {
                highLightedBodIds.add(bod.id);
            } else {
                notHighLightedBodIds.add(bod.id);
            }
        });

        productsFromPartialSections.forEach((bod) => {
            if (bod.is_highlighted) {
                highLightedBodIds.add(bod.id);
            } else {
                notHighLightedBodIds.add(bod.id);
            }
        });

        if ((highLightedBodIds.size && notHighLightedBodIds.size) || notHighLightedBodIds.size) {
            result.status = 'highlight';
            result.selectedIds = [...notHighLightedBodIds];
        } else {
            result.status = 'unhighlight';
            result.selectedIds = [...highLightedBodIds];
        }
        return result;
    }, [productsFromCompleteSections, productsFromPartialSections]);
};
